import React, { useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import CheckoutForm from "./CheckoutForm";
import Loading from "../../common/Loading";
import userService from "../../services/user.service";
import { Link } from "react-router-dom";

const NewBillingPage = () => {
  const location = useLocation();
  const { customerId, planData, paymentList } = location.state || {};
  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  console.log(location.state);

  const [isLoad, setIsLoad] = useState(true);
  const [activeTab, setActiveTab] = useState();
  const [activeTab1, setActiveTab1] = useState();

  const [customer, setCustomer] = useState();
  const [planFullData, setPlanFullData] = useState();
  const [payment, setPayment] = useState();
  const [subData, setSubData] = useState([]);
  const [cusDetails, setCusDetails] = useState({});

  useEffect(() => {
    setActiveTab(
      planData
        ? planData.renewalType
        : location.state
        ? location.state.planFullData.renewalType
        : "yearly"
    );
    setActiveTab1(
      planData
        ? planData.name
        : location.state
        ? location.state.planFullData.name
        : "Single"
    );
    setCustomer(customerId);
    setPlanFullData(planData);
    setPayment(paymentList);

    userService
      .userCheckAPI({
        email: UserDetails.email,
      })
      .then(
        (respo) => {
          console.log(respo);
          console.log(respo.data.rows[0].stripeCustomerId);
          if (respo.totalCount > 0) {
            setCusDetails(respo.data.rows[0].stripeCustomerId);
          } else {
            let userData = {
              name: UserDetails.firstname + " " + UserDetails.lastname,
              email: UserDetails.email,
            };

            userService.createCustomerStripe(userData).then(
              (response) => {
                //setShowPayment(true);
                setCusDetails(response.id);
                // get list of customer payment
              },
              () => {}
            );
          }
          userService.planList().then((response) => {
            const updatedResponse = response.map((plan) => {
              if (plan.renewalType === "yearly") {
                switch (plan.uniqueIdentifier) {
                  case "single-yearly":
                    return { ...plan, monthlyPrice: "4.17" };
                  case "couple-yearly":
                    return { ...plan, monthlyPrice: "5.83" };
                  case "family-yearly":
                    return { ...plan, monthlyPrice: "7.50" };
                  default:
                    return plan;
                }
              }
              return plan;
            });

            setSubData(updatedResponse);
            setTimeout(() => {
              setIsLoad(false);
            }, 500);
          });
        },
        () => {}
      );
  }, []);

  const handleSelect = (key) => {
    setActiveTab(key);
  };

  const handleSelect1 = (key) => {
    setActiveTab1(key);
  };

  useEffect(() => {
    const setHeight = () => {
      const container = document.getElementById("containerVal");
      const container1 = document.getElementById("containerVal1");
      console.log(window.innerWidth);

      if (container && window.innerWidth > 992) {
        console.log("ffffffffff");
        container.style.height = `${
          window.innerHeight > 800
            ? window.innerHeight
            : window.innerHeight > 600
            ? window.innerHeight + 100
            : window.innerHeight > 500
            ? window.innerHeight + 200
            : window.innerHeight + 300
        }px`;
      } else {
        container.style.height = "auto";
      }
      if (container1 && window.innerWidth > 992) {
        container1.style.height = `${
          window.innerHeight > 800
            ? window.innerHeight
            : window.innerHeight > 650
            ? window.innerHeight + 100
            : window.innerHeight > 500
            ? window.innerHeight + 200
            : window.innerHeight + 300
        }px`;
      } else {
        container1.style.height = "auto";
      }
    };

    window.addEventListener("resize", setHeight);
    window.addEventListener("click", setHeight);

    setHeight(); // Initial height setup

    return () => {
      window.removeEventListener("resize", setHeight);
      window.removeEventListener("click", setHeight);
    };
  }, []);

  useEffect(() => {
    for (let i = 0; i < subData.length; i++) {
      if (
        subData[i].name === activeTab1 &&
        subData[i].renewalType === activeTab
      ) {
        setPlanFullData(subData[i]);
      }
    }
  }, [activeTab, activeTab1, subData]);

  const planDescriptions = {
    Single: `Perfect for one person and a trusted supporter helping manage everyday life.`,

    Couple: `For couples, partners or close family support.`,

    Family: `For families supporting multiple loved ones together.`,
  };

  const planBulletPoints = {
    Single: [
      "One person + trusted supporter",
      "Shared reminders & organisation",
      "Household & renewal tracking",
      "Peace of mind for everyday life"
    ],
    Couple: [
      "Everything in Single Support",
      "Support each other together",
      "Shared organisation tools",
      "Multiple trusted supporters",
      "Designed for couples & families"
    ],
    Family: [
      "Everything in Joint Support",
      "Support multiple loved ones",
      "Shared household organisation",
      "Family-wide support access",
      "Built for connected care"
    ]
  };

  return (
    <div>
      <>
        <div className="container-fluid px-0 position-fixed top-0 w-100 h-100 overflow-auto">
          {/* Main Container  */}
          <Row className="mx-auto flex-column-reverse flex-lg-row">
            {/* Left Container */}
            <Col lg="12" className="bg-white order-2 order-lg-1">
              <div
                className="my-5 my-lg-0 d-lg-flex align-items-center justify-content-center text-white flex-column text-center  mx-1666"
                id="containerVal"
              >
                {isLoad ? (
                  <div
                    className="d-flex flex-column"
                    style={{ marginBottom: "5rem" }}
                  >
                    <Loading />
                  </div>
                ) : (
                  <>
                    <div className="fs-36 fw-bold bold-colour mb-3">
                      Add your billing details
                    </div>
                    <div className="d-flex align-items-center justify-content-between fs-14 mb-2 w-100">
                      <p className="fw-semibold bold-colour ">
                        <span class="text-success me-2">&#10004;</span>
                        <span>Cancel any time</span>
                      </p>
                      <p className="fw-semibold bold-colour ">
                        <span class="text-success me-2">&#10004;</span>
                        <span>No hidden costs</span>
                      </p>
                    </div>
                    <CheckoutForm
                      customerId={cusDetails} //
                      planDetails={
                        planFullData
                          ? planFullData
                          : location.state
                          ? location.state.planFullData
                          : ""
                      }
                      to
                    />
                  </>
                )}
              </div>
            </Col>

            {/* Right Container */}
            <Col lg="12" className="p-0 order-1 order-lg-2">
              <div
                className="d-flex align-items-center justify-content-center cont mx-1666"
                id="containerVal1"
              >
                <div className="d-flex flex-column">
                  <div className="px-2 p-6">
                    <h3>Select the Support Plan that Meets Your Needs</h3>

                    <div className="d-flex flex-column gap-1 mt-4">
                      <span class="text-dark d-flex flex-row gap-1">
                        <span>&#10004; </span>
                        <span>Select monthly or annual billing</span>
                      </span>

                      <span class="text-dark d-flex flex-row gap-1">
                        <span>&#10004; </span>
                        <span>
                          Choose the plan based on how many people need support
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="w-100">
                    <div
                      className={`story-card subscription-cards mb-3 bg-white br-12`}
                      style={{
                        boxShadow: "rgba(0, 123, 255, 0.2) 0px 3px 8px",
                      }}
                    >
                      {isLoad ? (
                        <div
                          className="d-flex flex-column"
                          style={{ height: "22rem" }}
                        >
                          <Loading />
                        </div>
                      ) : (
                        <div className="p-4 mt-4">
                          <div className="mb-4 fw-semibold bold-colour d-flex align-items-center justify-content-between new-billing-page">
                            <div className="text-center">
                              <span className="bg-primary rounded px-2 py-1 fs-14">
                                Select Billing
                              </span>
                              <Tabs
                                defaultActiveKey={activeTab}
                                id="uncontrolled-tab-example"
                                className="tab-container d-flex align-items-center fs-14 tab-leftOne mt-4"
                                style={{ border: "none" }}
                                onSelect={handleSelect}
                              >
                                <Tab
                                  eventKey="yearly"
                                  title="Annual"
                                  className="tab-annual mb-0 "
                                ></Tab>
                                <Tab
                                  eventKey="monthly"
                                  title="Monthly"
                                  className="tab-monthly mb-0 "
                                ></Tab>
                              </Tabs>
                            </div>

                            <div className="text-center">
                              <span className="bg-primary rounded px-2 py-1 fs-14">
                                Choose Plan
                              </span>
                              <Tabs
                                defaultActiveKey={activeTab1}
                                id="uncontrolled-tab-example"
                                className="tab-container d-flex align-items-center fs-14 tab-rightOne mt-4"
                                style={{ border: "none" }}
                                onSelect={handleSelect1}
                              >
                                <Tab
                                  eventKey="Single"
                                  title="Single"
                                  className="tab-annual mb-0 "
                                ></Tab>
                                <Tab
                                  eventKey="Couple"
                                  title="Joint"
                                  className="tab-annual mb-0 "
                                ></Tab>
                                <Tab
                                  eventKey="Family"
                                  title="Shared"
                                  className="tab-monthly mb-0 "
                                ></Tab>
                              </Tabs>
                            </div>
                          </div>
                          <>
                            <div className="mb-3">
                              <h1>
                                {/* {planFullData && planFullData.name} */}
                                {planFullData === "Single"
                                  ? "Single"
                                  : planFullData.name === "Couple"
                                  ? "Joint"
                                  : planFullData.name === "Family"
                                  ? "Shared"
                                  : planFullData.name}{" "}
                                Support
                              </h1>
                              <div className="text-info lh-sm mb-0">
                                {planFullData.renewalType === "yearly" ? (
                                  <div>
                                    <p className="fs-36 fw-bold mb-1">
                                      £{planFullData.monthlyPrice}
                                    </p>
                                    <p className="small text-dark mb-1">
                                      per month
                                    </p>
                                    <p className="text-dark mb-2 mb-md-2">
                                      Billed annually as{" "}
                                      <span className="text-info fw-bold">
                                        £{planFullData.price}
                                      </span>
                                    </p>
                                  </div>
                                ) : (
                                  <div>
                                    <span className="fs-36 fw-bold">
                                      £{planFullData.price}
                                    </span>
                                    <div className="small text-dark mb-2 mb-md-2">
                                      per{" "}
                                      {planFullData.renewalType === "yearly"
                                        ? "year"
                                        : "month"}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <p className="mb-4 mt-4">
                                {planDescriptions[planFullData.name]}
                              </p>
                            </div>
                            {planBulletPoints[planFullData.name]?.map((item, idx) => (
                              <p key={idx} className="fw-semibold bold-colour mb-2">
                                <span className="text-success me-2">&#10004;</span>
                                <span>{item}</span>
                              </p>
                            ))}
                          </>
                        </div>
                      )}
                    </div>

                    <div className="text-center mb-6rem">
                      <i
                        className="fas fa-smile"
                        style={{ color: "#d8d838" }}
                      ></i>
                      <div className="text-info fw-bold fs-14">
                        30 Days Free
                      </div>
                      <div className="mt-1 fs-14">
                        You won't be charged today. Cancel anytime – no stress,
                        no pressure
                      </div>
                      <div className="mt-1 fs-14">
                        Still unsure?
                        <a
                          className="text-reset fw-bold"
                          href="https://elderlylife.com/contact-us"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {" "}
                          Contact Us
                        </a>{" "}
                        or visit our
                        <a
                          className="text-reset fw-bold"
                          href="https://elderlylife.com/plans"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {" "}
                          Plans and Pricing{" "}
                        </a>
                        Page for more details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </>
      {/* )} */}
    </div>
  );
};

export default NewBillingPage;
